import React, { Component } from 'react'
import { domains } from '../../lib/config'

export default class CpuTraining extends Component {
  launchMod = modNum => {
    const cdnBase = `${domains.CDN_DOMAIN}/cpu/Module`
    const indexFile = '/scormcontent/index.html'
    const storyFile = '/story_html5.html'

    if (modNum !== '3K5') window.open(`${cdnBase}${modNum}${indexFile}`)
    else window.open(`${cdnBase}${modNum}${storyFile}`)
  }

  downloadCert = () => {
    window.open(`${domains.CDN_DOMAIN}/cpu/Training-Certificate.pdf`)
  }

  launchResources = () => window.open('/child-protection-training-resources')

  render() {
    return (
      <div>
        <div className="training-tx-container">
          <h3>Child Protection Unit Online Training Early Learning and K–5</h3>
          <p>
            We apologize for any inconvenience you’ve experienced while trying
            to access our online training. Please use the modules below instead
            to complete your training while we fix the problem.
          </p>
          <p>
            Select the section that best matches your role, and complete the
            modules in that section.
          </p>
          <p>
            This version of the training can’t save your place. If you need to
            pause the training, make note of where you left off so you can
            return to the same place later.
          </p>
          <p>
            When you’re finished, you can download or print a Certificate of
            Completion.
          </p>
        </div>
        <br />
        <h2 className="course-header">Early Learning Only</h2>
        <h4>Principal or program coordinator who WILL be teaching lessons</h4>
        <p className="strong-tx">Required:</p>
        <p>
          Leadership Module
          <br />
          All Staff Training Module (EL)
          <br />
          Teacher Training Module (EL)
        </p>
        <p className="strong-tx">Complete at least one:</p>

        <div className="course-list">
          <div className="course-item">
            <div className="course-number">1</div>
            <div className="course-title-wrap">
              <div className="course-title">Leadership Module</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="k-5-btn-launch-mod-1"
                onClick={() => this.launchMod('1')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">2</div>
            <div className="course-title-wrap">
              <div className="course-title">All-Staff Training Module (EL)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="k-5-btn-launch-mod-2EL"
                onClick={() => this.launchMod('2EL')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">3</div>
            <div className="course-title-wrap">
              <div className="course-title">Teacher Training Module (EL)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="k-5-btn-launch-mod-3EL"
                onClick={() => this.launchMod('3EL')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">4</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Certificate of Completion
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="k-5-btn-download-cert"
                onClick={this.downloadCert}
                roll="button"
              >
                <div className="button-text">download</div>
              </button>
            </div>
          </div>

          <div className="course-item course-last">
            <div className="course-number">5</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Resources
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="k-5-btn-launch-resources"
                onClick={this.launchResources}
                roll="button"
              >
                <div className="button-text">open</div>
              </button>
            </div>
          </div>
        </div>
        <br />

        <h4>Principal or program coordinator who WON’T be teaching lessons</h4>
        <p className="strong-tx">Required:</p>
        <p>
          Leadership Module
          <br />
          All Staff Training Module (EL)
        </p>
        <p className="strong-tx">Optional:</p>
        <p>Teacher Training Module (EL)</p>
        <div className="course-list">
          <div className="course-item">
            <div className="course-number">1</div>
            <div className="course-title-wrap">
              <div className="course-title">Leadership Module</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="leadership-btn-launch-mod-1"
                onClick={() => this.launchMod('1')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">2</div>
            <div className="course-title-wrap">
              <div className="course-title">All-Staff Training Module (EL)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="leadership-btn-launch-mod-2EL"
                onClick={() => this.launchMod('2EL')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">3</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Optional: Teacher Training Module (EL)
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="leadership-btn-launch-mod-3EL"
                onClick={() => this.launchMod('3EL')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">4</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Certificate of Completion
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="leadership-btn-download-cert"
                onClick={this.downloadCert}
                roll="button"
              >
                <div className="button-text">download</div>
              </button>
            </div>
          </div>

          <div className="course-item course-last">
            <div className="course-number">5</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Resources
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="leadership-btn-launch-resources"
                onClick={this.launchResources}
                roll="button"
              >
                <div className="button-text">open</div>
              </button>
            </div>
          </div>
        </div>
        <br />

        <h4>Teacher or counselor who WILL be teaching lessons</h4>
        <p className="strong-tx">Required:</p>
        <p>
          All Staff Training Module (EL)
          <br />
          Teacher Training Module (EL)
        </p>
        <div className="course-list">
          <div className="course-item">
            <div className="course-number">2</div>
            <div className="course-title-wrap">
              <div className="course-title">All-Staff Training Module (EL)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="teacher-btn-launch-mod-2EL"
                onClick={() => this.launchMod('2EL')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">3</div>
            <div className="course-title-wrap">
              <div className="course-title">Teacher Training Module (EL)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="teacher-btn-launch-mod-3EL"
                onClick={() => this.launchMod('3EL')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">4</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Certificate of Completion
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="teacher-btn-download-cert"
                onClick={this.downloadCert}
                roll="button"
              >
                <div className="button-text">download</div>
              </button>
            </div>
          </div>

          <div className="course-item course-last">
            <div className="course-number">5</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Resources
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="teacher-btn-launch-resources"
                onClick={this.launchResources}
                roll="button"
              >
                <div className="button-text">open</div>
              </button>
            </div>
          </div>
        </div>
        <br />

        <h4>Teacher or counselor who WON’T be teaching lessons</h4>
        <p className="strong-tx">Required:</p>
        <p>All Staff Training Module (EL)</p>
        <div className="course-list">
          <div className="course-item">
            <div className="course-number">2</div>
            <div className="course-title-wrap">
              <div className="course-title">All-Staff Training Module (EL)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="teacher-non-teaching-btn-launch-mod-2EL"
                onClick={() => this.launchMod('2EL')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">4</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Certificate of Completion
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="teacher-non-teaching-btn-download-cert"
                onClick={this.downloadCert}
                roll="button"
              >
                <div className="button-text">download</div>
              </button>
            </div>
          </div>

          <div className="course-item course-last">
            <div className="course-number">5</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Resources
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="teacher-non-teaching-btn-launch-resources"
                onClick={this.launchResources}
                roll="button"
              >
                <div className="button-text">open</div>
              </button>
            </div>
          </div>
        </div>
        <br />

        <h4>Other school staff member who WILL be teaching the lessons</h4>
        <p className="strong-tx">Required:</p>
        <p>
          All Staff Training Module (EL)
          <br />
          Teacher Training Module (EL)
        </p>
        <div className="course-list">
          <div className="course-item">
            <div className="course-number">2</div>
            <div className="course-title-wrap">
              <div className="course-title">All-Staff Training Module (EL)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="other-staff-btn-launch-mod-2EL"
                onClick={() => this.launchMod('2EL')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">3</div>
            <div className="course-title-wrap">
              <div className="course-title">Teacher Training Module (EL)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="other-staff-btn-launch-mod-3EL"
                onClick={() => this.launchMod('3EL')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">4</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Certificate of Completion
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="other-staff-btn-download-cert"
                onClick={this.downloadCert}
                roll="button"
              >
                <div className="button-text">download</div>
              </button>
            </div>
          </div>

          <div className="course-item course-last">
            <div className="course-number">5</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Resources
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="other-staff-btn-launch-resources"
                onClick={this.launchResources}
                roll="button"
              >
                <div className="button-text">open</div>
              </button>
            </div>
          </div>
        </div>
        <br />

        <h4>Other school staff member who WON’T be teaching the lessons</h4>
        <p className="strong-tx">Required:</p>
        <p>All Staff Training Module (EL)</p>
        <div className="course-list">
          <div className="course-item">
            <div className="course-number">2</div>
            <div className="course-title-wrap">
              <div className="course-title">All-Staff Training Module (EL)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="other-other-staff-btn-launch-mod-2EL"
                onClick={() => this.launchMod('2EL')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">4</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Certificate of Completion
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="other-other-staff-btn-download-cert"
                onClick={this.downloadCert}
                roll="button"
              >
                <div className="button-text">download</div>
              </button>
            </div>
          </div>

          <div className="course-item course-last">
            <div className="course-number">5</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Resources
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="other-other-staff-btn-launch-resources"
                onClick={this.launchResources}
                roll="button"
              >
                <div className="button-text">open</div>
              </button>
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />
        <br />

        <h2 className="course-header">K–5 Only</h2>
        <h4>Principal or program coordinator who WILL be teaching lessons</h4>
        <p className="strong-tx">Required:</p>
        <p>
          Leadership Module
          <br />
          All Staff Training Module (K5)
          <br />
          Teacher Training Module (K5)
        </p>
        <div className="course-list">
          <div className="course-item">
            <div className="course-number">1</div>
            <div className="course-title-wrap">
              <div className="course-title">Leadership Module</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="leadership-will-btn-launch-mod-1K5"
                onClick={() => this.launchMod('1')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">2</div>
            <div className="course-title-wrap">
              <div className="course-title">All-Staff Training Module (K5)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="leadership-will-btn-launch-mod-2K5"
                onClick={() => this.launchMod('2K5')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">3</div>
            <div className="course-title-wrap">
              <div className="course-title">Teacher Training Module (K5)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="leadership-will-btn-launch-mod-3K5"
                onClick={() => this.launchMod('3K5')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">4</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Certificate of Completion
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="leadership-will-btn-download-cert"
                onClick={this.downloadCert}
                roll="button"
              >
                <div className="button-text">download</div>
              </button>
            </div>
          </div>

          <div className="course-item course-last">
            <div className="course-number">5</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Resources
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="leadership-will-btn-launch-resources"
                onClick={this.launchResources}
                roll="button"
              >
                <div className="button-text">open</div>
              </button>
            </div>
          </div>
        </div>
        <br />

        <h4>Principal or program coordinator who WON’T be teaching lessons</h4>
        <p>Leadership Module</p>
        <p className="strong-tx">Required:</p>
        <p>
          Leadership Module
          <br />
          All Staff Training Module (K5)
        </p>
        <p className="strong-tx">Optional:</p>
        <p>Teacher Training Module (K5)</p>
        <div className="course-list">
          <div className="course-item">
            <div className="course-number">1</div>
            <div className="course-title-wrap">
              <div className="course-title">Leadership Module</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="leadership-wont-btn-launch-mod-1"
                onClick={() => this.launchMod('1')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">2</div>
            <div className="course-title-wrap">
              <div className="course-title">All-Staff Training Module (K5)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="leadership-wont-btn-launch-mod-2K5"
                onClick={() => this.launchMod('2K5')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">3</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Optional: Teacher Training Module (K5)
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="leadership-wont-btn-launch-mod-3K5"
                onClick={() => this.launchMod('3K5')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">4</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Certificate of Completion
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="leadership-wont-btn-download-cert"
                onClick={this.downloadCert}
                roll="button"
              >
                <div className="button-text">download</div>
              </button>
            </div>
          </div>

          <div className="course-item course-last">
            <div className="course-number">5</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Resources
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="leadership-wont-btn-launch-resources"
                onClick={this.launchResources}
                roll="button"
              >
                <div className="button-text">open</div>
              </button>
            </div>
          </div>
        </div>
        <br />

        <h4>Teacher or counselor who WILL be teaching lessons</h4>
        <p className="strong-tx">Required:</p>
        <p>
          All Staff Training Module (K5)
          <br />
          Teacher Training Module (K5)
        </p>
        <div className="course-list">
          <div className="course-item">
            <div className="course-number">2</div>
            <div className="course-title-wrap">
              <div className="course-title">All-Staff Training Module (K5)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="teachers-counselors-btn-launch-mod-2K5"
                onClick={() => this.launchMod('2K5')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">3</div>
            <div className="course-title-wrap">
              <div className="course-title">Teacher Training Module (K5)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="teachers-counselors-btn-launch-mod-3K5"
                onClick={() => this.launchMod('3K5')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">4</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Certificate of Completion
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="teachers-counselors-btn-download-cert"
                onClick={this.downloadCert}
                roll="button"
              >
                <div className="button-text">download</div>
              </button>
            </div>
          </div>

          <div className="course-item course-last">
            <div className="course-number">5</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Resources
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="teachers-counselors-btn-launch-resources"
                onClick={this.launchResources}
                roll="button"
              >
                <div className="button-text">open</div>
              </button>
            </div>
          </div>
        </div>
        <br />

        <h4>Teacher or counselor who WON’T be teaching lessons</h4>
        <p className="strong-tx">Required:</p>
        <p>All Staff Training Module (K5)</p>
        <div className="course-list">
          <div className="course-item">
            <div className="course-number">2</div>
            <div className="course-title-wrap">
              <div className="course-title">All-Staff Training Module (K5)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="teachers-counselors-wont--btn-launch-mod-2K5"
                onClick={() => this.launchMod('2K5')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">4</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Certificate of Completion
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="teachers-counselors-wont--btn-download-cert"
                onClick={this.downloadCert}
                roll="button"
              >
                <div className="button-text">download</div>
              </button>
            </div>
          </div>

          <div className="course-item course-last">
            <div className="course-number">5</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Resources
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="teachers-counselors-wont--btn-launch-resources"
                onClick={this.launchResources}
                roll="button"
              >
                <div className="button-text">open</div>
              </button>
            </div>
          </div>
        </div>
        <br />

        <h4>Other school staff member who WILL be teaching the lessons</h4>
        <p className="strong-tx">Required:</p>
        <p>
          All Staff Training Module (K5)
          <br />
          Teacher Training Module (K5)
        </p>
        <div className="course-list">
          <div className="course-item">
            <div className="course-number">2</div>
            <div className="course-title-wrap">
              <div className="course-title">All-Staff Training Module (K5)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="other-will-btn-launch-mod-2K5"
                onClick={() => this.launchMod('2K5')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">3</div>
            <div className="course-title-wrap">
              <div className="course-title">Teacher Training Module (K5)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="other-will-btn-launch-mod-3K5"
                onClick={() => this.launchMod('3K5')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">4</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Certificate of Completion
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="other-will-btn-download-cert"
                onClick={this.downloadCert}
                roll="button"
              >
                <div className="button-text">download</div>
              </button>
            </div>
          </div>

          <div className="course-item course-last">
            <div className="course-number">5</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Resources
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="other-will-btn-launch-resources"
                onClick={this.launchResources}
                roll="button"
              >
                <div className="button-text">open</div>
              </button>
            </div>
          </div>
        </div>
        <br />

        <h4>Other school staff member who WON’T be teaching the lessons</h4>
        <p className="strong-tx">Required:</p>
        <p>Teacher Training Module (K5)</p>
        <div className="course-list">
          <div className="course-item">
            <div className="course-number">2</div>
            <div className="course-title-wrap">
              <div className="course-title">All-Staff Training Module (K5)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="other-wont-btn-launch-mod-2K5"
                onClick={() => this.launchMod('2K5')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">4</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Certificate of Completion
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="other-wont-btn-download-cert"
                onClick={this.downloadCert}
                roll="button"
              >
                <div className="button-text">download</div>
              </button>
            </div>
          </div>

          <div className="course-item course-last">
            <div className="course-number">5</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Resources
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="other-wont-btn-launch-resources"
                onClick={this.launchResources}
                roll="button"
              >
                <div className="button-text">open</div>
              </button>
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />
        <br />

        <h2 className="course-header">Early Learning and K–5</h2>
        <h4>Principal or program coordinator who WILL be teaching lessons</h4>
        <p className="strong-tx">Required:</p>
        <p>Leadership Module</p>
        <p className="strong-tx">Complete at least one:</p>
        <p>
          All Staff Training Module (EL)
          <br /> All Staff Training Module (K–5)
        </p>
        <p className="strong-tx">Complete at least one:</p>
        <p>
          Teacher Training Module (EL)
          <br />
          Teacher Training Module (K–5)
        </p>
        <div className="course-list">
          <div className="course-item">
            <div className="course-number">1</div>
            <div className="course-title-wrap">
              <div className="course-title">Leadership Module</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="principal-pc-will-btn-launch-mod-1"
                onClick={() => this.launchMod('1')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">2</div>
            <div className="course-title-wrap">
              <div className="course-title">All-Staff Training Module (EL)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="principal-pc-will-btn-launch-mod-2EL"
                onClick={() => this.launchMod('2EL')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">2</div>
            <div className="course-title-wrap">
              <div className="course-title">All-Staff Training Module (K5)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="principal-pc-will-btn-launch-mod-2K5"
                onClick={() => this.launchMod('2K5')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">3</div>
            <div className="course-title-wrap">
              <div className="course-title">Teacher Training Module (EL)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="principal-pc-will-btn-launch-mod-3EL"
                onClick={() => this.launchMod('3EL')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">3</div>
            <div className="course-title-wrap">
              <div className="course-title">Teacher Training Module (K5)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="principal-pc-will-btn-launch-mod-3K5"
                onClick={() => this.launchMod('3K5')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">4</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Certificate of Completion
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="principal-pc-will-btn-download-cert"
                onClick={this.downloadCert}
                roll="button"
              >
                <div className="button-text">download</div>
              </button>
            </div>
          </div>

          <div className="course-item course-last">
            <div className="course-number">5</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Resources
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="principal-pc-will-bt-launch-resources"
                onClick={this.launchResources}
                roll="button"
              >
                <div className="button-text">open</div>
              </button>
            </div>
          </div>
        </div>
        <br />

        <h4>Principal or program coordinator who WON’T be teaching lessons</h4>
        <p className="strong-tx">Required:</p>
        <p>Leadership Module</p>
        <p className="strong-tx">Complete at least one:</p>
        <p>
          All Staff Training Module (EL)
          <br /> All Staff Training Module (K5)
        </p>
        <p className="strong-tx">Optional:</p>
        <p>
          Teacher Training Module (EL)
          <br />
          Teacher Training Module (K5)
        </p>
        <div className="course-list">
          <div className="course-item">
            <div className="course-number">1</div>
            <div className="course-title-wrap">
              <div className="course-title">Leadership Module</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="principal-pc-wont-btn-launch-mod-1"
                onClick={() => this.launchMod('1')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">2</div>
            <div className="course-title-wrap">
              <div className="course-title">All-Staff Training Module (EL)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="principal-pc-wont-btn-launch-mod-2EL"
                onClick={() => this.launchMod('2EL')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">2</div>
            <div className="course-title-wrap">
              <div className="course-title">All-Staff Training Module (K5)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="principal-pc-wont-btn-launch-mod-2K5"
                onClick={() => this.launchMod('2K5')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">3</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Optional: Teacher Training Module (EL)
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="principal-pc-wont-btn-launch-mod-3EL"
                onClick={() => this.launchMod('3EL')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">3</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Optional: Teacher Training Module (K5)
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="principal-pc-wont-btn-launch-mod-3K5"
                onClick={() => this.launchMod('3K5')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">4</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Certificate of Completion
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="principal-pc-wont-btn-download-cert"
                onClick={this.downloadCert}
                roll="button"
              >
                <div className="button-text">download</div>
              </button>
            </div>
          </div>

          <div className="course-item course-last">
            <div className="course-number">5</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Resources
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="principal-pc-wont-bt-launch-resources"
                onClick={this.launchResources}
                roll="button"
              >
                <div className="button-text">open</div>
              </button>
            </div>
          </div>
        </div>
        <br />

        <h4>Teacher or counselor who WILL be teaching lessons</h4>
        <p className="strong-tx">Required:</p>
        <p>
          All Staff Training Module (EL)
          <br /> All Staff Training Module (K5)
        </p>
        <p className="strong-tx">Complete at least one</p>
        <p>
          Teacher Training Module (EL)
          <br />
          Teacher Training Module (K5)
        </p>
        <div className="course-list">
          <div className="course-item">
            <div className="course-number">2</div>
            <div className="course-title-wrap">
              <div className="course-title">All-Staff Training Module (EL)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="teacher-counselor-will-btn-launch-mod-2EL"
                onClick={() => this.launchMod('2EL')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">2</div>
            <div className="course-title-wrap">
              <div className="course-title">All-Staff Training Module (K5)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="teacher-counselor-will-btn-launch-mod-2K5"
                onClick={() => this.launchMod('2K5')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">3</div>
            <div className="course-title-wrap">
              <div className="course-title">Teacher Training Module (EL)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="teacher-counselor-will-btn-launch-mod-3EL"
                onClick={() => this.launchMod('3EL')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">3</div>
            <div className="course-title-wrap">
              <div className="course-title">Teacher Training Module (K5)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="teacher-counselor-will-btn-launch-mod-3K5"
                onClick={() => this.launchMod('3K5')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">4</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Certificate of Completion
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="teacher-counselor-will-btn-download-cert"
                onClick={this.downloadCert}
                roll="button"
              >
                <div className="button-text">download</div>
              </button>
            </div>
          </div>

          <div className="course-item course-last">
            <div className="course-number">5</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Resources
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="teacher-counselor-will-bt-launch-resources"
                onClick={this.launchResources}
                roll="button"
              >
                <div className="button-text">open</div>
              </button>
            </div>
          </div>
        </div>
        <br />

        <h4>Teacher or counselor who WON’T be teaching lessons</h4>
        <p className="strong-tx">Complete at least one:</p>
        <p>
          All Staff Training Module (EL)
          <br /> All Staff Training Module (K5)
        </p>
        <div className="course-list">
          <div className="course-item">
            <div className="course-number">2</div>
            <div className="course-title-wrap">
              <div className="course-title">All-Staff Training Module (EL)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="teacher-counselor-wont-btn-launch-mod-2EL"
                onClick={() => this.launchMod('2EL')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">2</div>
            <div className="course-title-wrap">
              <div className="course-title">All-Staff Training Module (K5)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="teacher-counselor-wont-btn-launch-mod-2K5"
                onClick={() => this.launchMod('2K5')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">4</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Certificate of Completion
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="teacher-counselor-wont-btn-download-cert"
                onClick={this.downloadCert}
                roll="button"
              >
                <div className="button-text">download</div>
              </button>
            </div>
          </div>

          <div className="course-item course-last">
            <div className="course-number">5</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Resources
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="teacher-counselor-will-wont-launch-resources"
                onClick={this.launchResources}
                roll="button"
              >
                <div className="button-text">open</div>
              </button>
            </div>
          </div>
        </div>
        <br />

        <h4>Other school staff member who WILL be teaching the lessons</h4>
        <p className="strong-tx">Required:</p>
        <p>
          Teacher Training Module (EL)
          <br />
          Teacher Training Module (K5)
        </p>
        <p className="strong-tx">Complete at least one:</p>
        <p>
          All Staff Training Module (EL)
          <br /> All Staff Training Module (K5)
        </p>
        <p className="strong-tx">Optional:</p>
        <div className="course-list">
          <div className="course-item">
            <div className="course-number">2</div>
            <div className="course-title-wrap">
              <div className="course-title">All-Staff Training Module (EL)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="other-school-will-btn-launch-mod-2EL"
                onClick={() => this.launchMod('2EL')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">2</div>
            <div className="course-title-wrap">
              <div className="course-title">All-Staff Training Module (K5)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="other-school-counselor-will-btn-launch-mod-2K5"
                onClick={() => this.launchMod('2K5')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">3</div>
            <div className="course-title-wrap">
              <div className="course-title">Teacher Training Module (EL)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="other-school-will-btn-launch-mod-3EL"
                onClick={() => this.launchMod('3EL')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">3</div>
            <div className="course-title-wrap">
              <div className="course-title">Teacher Training Module (K5)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="other-school-will-btn-launch-mod-3K5"
                onClick={() => this.launchMod('3K5')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">4</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Certificate of Completion
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="other-school-will-btn-download-cert"
                onClick={this.downloadCert}
                roll="button"
              >
                <div className="button-text">download</div>
              </button>
            </div>
          </div>

          <div className="course-item course-last">
            <div className="course-number">5</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Resources
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="other-school-will-bt-launch-resources"
                onClick={this.launchResources}
                roll="button"
              >
                <div className="button-text">open</div>
              </button>
            </div>
          </div>
        </div>
        <br />

        <h4>Other school staff member who WON’T be teaching the lessons</h4>
        <p className="strong-tx">Complete at least one:</p>
        <p>
          All Staff Training Module (EL)
          <br /> All Staff Training Module (K5)
        </p>
        <div className="course-list">
          <div className="course-item">
            <div className="course-number">2</div>
            <div className="course-title-wrap">
              <div className="course-title">All-Staff Training Module (EL)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="other-school-wont-btn-launch-mod-2EL"
                onClick={() => this.launchMod('2EL')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">2</div>
            <div className="course-title-wrap">
              <div className="course-title">All-Staff Training Module (K5)</div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="other-school-counselor-wont-btn-launch-mod-2K5"
                onClick={() => this.launchMod('2K5')}
                roll="button"
              >
                <div className="button-text">start</div>
              </button>
            </div>
          </div>

          <div className="course-item">
            <div className="course-number">4</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Certificate of Completion
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="other-school-wont-btn-download-cert"
                onClick={this.downloadCert}
                roll="button"
              >
                <div className="button-text">download</div>
              </button>
            </div>
          </div>

          <div className="course-item course-last">
            <div className="course-number">5</div>
            <div className="course-title-wrap">
              <div className="course-title">
                Child Protection Unit Online Training Resources
              </div>
            </div>
            <div className="course-buttons">
              <button
                className="btn-start"
                data-testid="other-school-wont-bt-launch-resources"
                onClick={this.launchResources}
                roll="button"
              >
                <div className="button-text">open</div>
              </button>
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />
        <style jsx>
          {`
            .training-tx-container {
              padding-right: 30%;
            }

            h4 {
              font-size: 2rem;
              color: #f5961f;
              padding: 20px 0 5px 0;
            }

            h5 {
              font-weight: 100;
            }

            .strong-tx {
              font-weight: bold;
              margin-bottom: 0px;
            }

            .course-header {
              margin: 20px 0 0;
              padding: 0;
              line-height: 0;
            }

            .course-list {
              padding: 0 1rem;
              background-color: #eee;
            }

            .course-item {
              box-sizing: border-box;
              background-color: transparent;
              display: flex;
              border-bottom: 1px solid #bdbdbd;
              padding: 1rem 0;
            }

            .course-item.course-last {
              border-color: transparent;
            }

            .course-item button {
              cursor: pointer;
              height: 2.75rem;
              width: 8.75rem;
              border: 2px solid #002855;
              font-size: 1rem;
              margin: 0 0 0 1rem;
              text-transform: capitalize;
            }

            .course-item button:focus {
              border: 2px solid #42a5f5;
            }

            .course-item button .button-text {
              padding-bottom: 1px;
            }

            .course-number {
              display: none;
            }

            .course-title-wrap {
              width: 100%;
              display: flex;
              justify-content: space-between;
            }

            .course-title {
              display: flex;
              justify-content: left;
              align-items: center;
              min-width: 10rem;
              height: 2.8125rem;
              font-size: 1rem;
              font-weight: 700;
              overflow: hidden;
              text-overflow: ellipsis;
              color: #444;
              background-color: transparent;
              pointer-events: none;
            }

            .course-buttons {
              display: flex;
              align-items: center;
              justify-content: flex-end;
              background-color: transparent;
              white-space: nowrap;
              width: 18.75rem;
            }

            .course-buttons .btn-start {
              background-color: #002855;
              color: #fff;
            }

            .course-buttons .btn-start:hover {
              background-color: #4e6987;
              border-color: #4e6987;
              color: #fff;
            }

            @media (max-width: 768px) {
              .training-tx-container {
                padding-right: 0;
              }

              .course-title-wrap {
                flex-direction: column;
                justify-content: center;
              }

              .course-title {
                align-items: end;
                height: initial;
              }

              .course-buttons {
                flex-wrap: wrap;
              }

              .course-buttons button {
                margin: 0.25rem;
              }
            }
          `}
        </style>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/static-training/CpuTraining.js